import { render } from "./TotalPrice.vue?vue&type=template&id=1511bc27"
import script from "./TotalPrice.vue?vue&type=script&lang=js"
export * from "./TotalPrice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__